import type { GoodsCategory, PaymentTerm, Supplier } from './types'

/**
 * Goods categories are derived from supplier formats
 * (`supplierFormatService` → `categoriesFromFormats`).
 */

/** @deprecated Prefer supplierService.listCategories() (from formats). */
export const GOODS_CATEGORIES: GoodsCategory[] = []

export const PAYMENT_TERMS: PaymentTerm[] = [
  { id: 'pt-cod', code: 'COD', name: 'COD', days: 0, isActive: true },
  { id: 'pt-net7', code: 'NET7', name: 'Net 7', days: 7, isActive: true },
  { id: 'pt-net15', code: 'NET15', name: 'Net 15', days: 15, isActive: true },
  { id: 'pt-net21', code: 'NET21', name: 'Net 21', days: 21, isActive: true },
  { id: 'pt-net30', code: 'NET30', name: 'Net 30', days: 30, isActive: true },
  { id: 'pt-net45', code: 'NET45', name: 'Net 45', days: 45, isActive: true },
]

export const SEED_SUPPLIERS: Supplier[] = []
